import { InfoEntry } from './InfoEntry';

type DataEntry = { name: string; displayName: string; value: string | null };

export type InfoProps = {
    estateSize: string | null;
    noOfBedrooms: string | null;
    noOfBeds: string | null;
    noOfBathrooms: string | null;
    propertyType: string | null;
};

export const Info = ({ estateSize, noOfBedrooms, noOfBeds, noOfBathrooms, propertyType }: InfoProps) => {
    const entryData: DataEntry[] = [
        { name: 'propertyType', displayName: 'Boligtype', value: propertyType },
        { name: 'estateSize', displayName: 'Størrelse', value: estateSize },
        { name: 'noOfBedrooms', displayName: 'Soverom', value: noOfBedrooms },
        { name: 'noOfBeds', displayName: 'Senger', value: noOfBeds },
        { name: 'noOfBathrooms', displayName: 'Baderom', value: noOfBathrooms },
    ];

    const entries = entryData
        .filter((entry): entry is DataEntry & { value: string } => Boolean(entry.value))
        .map(({ name, displayName, value }) => (
            <InfoEntry key={`list-${name}`} description={displayName} value={value} data-testid={`adInfo-${name}`} />
        ));

    return (
        <div className="grid grid-cols-2 md:grid-cols-5 gap-16" data-testid="adInfo">
            {entries}
        </div>
    );
};
